const editaisEncerrados = [
  {
    id: 11,
    titulo: "Edital Turma 8 - Híbrida",
    descricao: "Este edital destina-se à formação da 8ª turma do Projeto Web Academy.",
    documentos: [
      {
        data: "",
        titulo: "Edital Turma 8 - Seleção de Discentes",
        arquivo: "files/edital_turma_8_hibrida/Projeto_Web_Academy_-Edital_Turma_8_-Hibrida.pdf"
      },
      {
        data: "",
        titulo: "Formulário para Requerimento de Inscrição",
        arquivo: "https://forms.gle/qrVwABY9s3nGbuXY6",
        hyperlink: false,
      },
      {
        data: "",
        titulo: "Edital Turma 8 Retificado - Seleção de Discentes",
        arquivo: "files/edital_turma_8_hibrida/Projeto_Web_Academy_-Edital_Turma_8_-Híbrida_-Retificado.docx.pdf"
      },
      {
        data: "",
        titulo: "Resultado Preliminar da Etapa 1",
        arquivo: "files/edital_turma_8_hibrida/Projeto_Web_Academy_-Edital_Turma_8_-Híbrida_-Resultado_Preliminar_da_Etapa_1.pdf"
      },
      {
        data: "",
        titulo: "Resultado Final da Etapa 1",
        arquivo: "files/edital_turma_8_hibrida/Projeto_Web_Academy_-Edital_Turma_8_-Híbrida_-Resultado_Final_da_Etapa_1.pdf"
      },
      {
        data: "",
        titulo: "Convocação para Etapa 2",
        arquivo: "files/edital_turma_8_hibrida/Projeto_Web_Academy_-Edital_Turma_8_-Híbrida_-Convocação_para_Etapa_2.pdf"
      },
      {
        data: "",
        titulo: "Resultado Preliminar da Etapa 2",
        arquivo: "files/edital_turma_8_hibrida/Projeto_Web_Academy_-Edital_Turma_8_-Híbrida_-Resultado_Preliminar_da_Etapa_2.pdf"
      },
      {
        data: "",
        titulo: "Edital Turma 8 Retificado - Seleção de Discentes",
        arquivo: "files/edital_turma_8_hibrida/Projeto_Web_Academy_-Edital_Turma_8_-Híbrida_-Retificado.pdf"
      },
      {
        data: "",
        titulo: "Resultado Final da Etapa 2",
        arquivo: "files/edital_turma_8_hibrida/Projeto_Web_Academy_-Edital_Turma_8_-Híbrida_-Resultado_Final_da_Etapa_2.pdf"
      },
      {
        data: "",
        titulo: "Convocação para Etapa 3",
        arquivo: "files/edital_turma_8_hibrida/Projeto_Web_Academy_-Edital_Turma_8_-Híbrida_-Convocação_para_Etapa_3.pdf"
      },
      {
        data: "",
        titulo: "Resultado Final Preliminar",
        arquivo: "files/edital_turma_8_hibrida/Projeto_Web_Academy_-Edital_Turma_8_-Híbrida_-Resultado_Preliminar_Final.pdf"
      }
    ]
  },
  {
    id: 10,
    titulo: 'Edital 002/2026 - Turma 7 - Processo Seletivo',
    documentos: [
      {
        titulo: 'Edital 002/2026 - Seleção de candidatos',
        data: "",
        arquivo:
          'files/processo_seletivo_edital_002_2026/Processo_Seletivo_002_2026_-Analista_de_Desenvolvimento.docx_assinado.pdf'
      },
      {
        titulo: 'Resultado Preliminar da Etapa 1',
        data: "",
        arquivo:
        'files/processo_seletivo_edital_002_2026/Processo_Seletivo_002_2026_-Analista_de_Desenvolvimento_-RESULTADO_PRELIMINAR_ETAPA_1.pdf'
      },
      {
        titulo: 'Cronograma Atualizado',
        data: "",
        arquivo:
        'files/processo_seletivo_edital_002_2026/Processo_Seletivo_002_2026_-Analista_de_Desenvolvimento_-RETIFICADO.pdf'
      },
      {
        titulo: 'Resultado Final da Etapa 1',
        data: "",
        arquivo:
        'files/processo_seletivo_edital_002_2026/Processo_Seletivo_002_2026_-Analista_de_Desenvolvimento_-RESULTADO_FINAL_ETAPA_1.pdf'
      },
      {
        titulo: 'Resultado Preliminar do Processo Seletivo',
        data: "",
        arquivo:
        'files/processo_seletivo_edital_002_2026/Processo_Seletivo_002_2026_-Analista_de_Desenvolvimento_-RESULTADO_PRELIMINAR.pdf'
      },
      {
        titulo: 'Resultado Final do Processo Seletivo',
        data: "",
        arquivo:
        'files/processo_seletivo_edital_002_2026/Processo_Seletivo_002_2026_-Analista_de_Desenvolvimento_-RESULTADO_FINAL.pdf'
      }
    ]
  },
  {
    id: 9,
    titulo: 'Edital 001/2026 - Turma 7',
    documentos: [
      {
        titulo: 'Edital 001/2026 - Seleção de Discentes',
        data: "",
        arquivo:
          'files/edital_001_2026/Projeto_Web_Academy_Edital_Turma_7_Hibrida.pdf',
      },
      {
        titulo: 'Resultado Preliminar da Homologação e da Primeira Fase',
        data: "",
        arquivo:
          'files/edital_001_2026/Projeto_Web_Academy_Edital_Turma_7_Resultado_Preliminar_Homologação_e_Primeira_Fase.pdf',
      },
      {
        titulo: 'Resultado Final da Primeira Fase e Convocação para 2ª Etapa',
        data: "",
        arquivo:
          'files/edital_001_2026/Projeto_Web_Academy_Edital_Turma_7_Resultado_Homologacao_e_Primeira_Fase_Convocacao.pdf',
      },
      {
        titulo: 'Resultado Preliminar da 2ª Etapa',
        data: "",
        arquivo:
          'files/edital_001_2026/Projeto_Web_Academy_Edital_Turma_7_Resultado_Preliminar_da_Segunda_Fase.pdf',
      },
      {
        titulo: 'Resultado Final da 2ª Etapa',
        data: "",
        arquivo:
          'files/edital_001_2026/Projeto_Web_Academy_Edital_Turma_7_Resultado_da_Segunda_Fase.pdf',
      },
      {
        titulo: 'Resultado Final Preliminar',
        data: "",
        arquivo:
          'files/edital_001_2026/Projeto_Web_Academy_Edital_Turma_7_Resultado_Final_Preliminar.pdf',
      },
      {
        titulo: 'Resultado Final',
        data: "",
        arquivo:
          'files/edital_001_2026/Projeto_Web_Academy_Edital_Turma_7_Resultado_Final.pdf',
      },
    ],
  },
  {
    id: 8,
    titulo: 'Edital 004/2025 - Turma 6',
    documentos: [
      {
        titulo: 'Edital 004/2025 - Seleção de Discentes',
        data: "",
        arquivo:
          'files/edital_004_2025/Projeto_Web_Academy_Edital_Turma_6_Presencial.pdf',
      },
      {
        titulo: 'Resultado Preliminar da Etapa 1',
        data: "",
        arquivo:
          'files/edital_004_2025/Projeto_Web_Academy_Edital_Turma_6_Resultado_Preliminar_da_Primeira_Fase.pdf',
      },
      {
        titulo: 'Resultado Final da Primeira Fase e Convocação para 2ª Etapa',
        data: "",
        arquivo:
          'files/edital_004_2025/Projeto_Web_Academy_Edital_Turma_6_Resultado_Final_da_Primeira_Fase.pdf',
      },
      {
        titulo: 'Resultado Final Preliminar',
        data: "",
        arquivo:
          'files/edital_004_2025/Projeto_Web_Academy_Edital_Turma_6_Resultado_Final_Preliminar.pdf',
      },
      {
        titulo: 'Resultado Final',
        data: "",
        arquivo:
          'files/edital_004_2025/Projeto_Web_Academy_Edital_Turma_6_Resultado_Final.pdf',
      },
    ],
  },
  {
    id: 7,
    titulo: 'Edital 003/2025 - Turma 1 - EaD - VAGAS SUPLEMENTARES',
    documentos: [
      {
        titulo: 'Edital 003/2025 - Seleção de Discentes',
        data: "",
        arquivo:
          'files/edital_003_2025_ead/Projeto_Web_Academy_Edital_003_2025_Selecao_de_Discentes_Turma_1_EaD.pdf',
      },
      {
        titulo: 'Resultado Preliminar da Etapa 1',
        data: "",
        arquivo:
          'files/edital_003_2025_ead/Projeto_Web_Academy_Edital_003_2025_Resultado_Preliminar_da_Etapa_1.pdf',
      },
      {
        titulo: 'Resultado Final Preliminar',
        data: "",
        arquivo:
          'files/edital_003_2025_ead/Projeto_Web_Academy_Edital_003_2025_Resultado_Final_Preliminar.pdf',
      },
      {
        titulo: 'Resultado Final',
        data: "",
        arquivo:
          'files/edital_003_2025_ead/Projeto_Web_Academy_Edital_003_2025_Resultado_Final.pdf',
      },
    ],
  },
  {
    id: 6,
    titulo: 'Edital 002/2025 - Turma 1 - EaD',
    documentos: [
      {
        titulo: 'Edital 002/2025 - Seleção de Discentes',
        data: "",
        arquivo:
          'files/edital_002_2025_ead/Projeto_Web_Academy_Edital_002_2025_Selecao_de_Discentes_Turma_1_EaD.pdf',
      },
      {
        titulo: 'Resultado Preliminar da Homologação',
        data: "",
        arquivo:
          'files/edital_002_2025_ead/Projeto_Web_Academy_Edital_002_2025_Resultado_Preliminar_da_Homologacao.pdf',
      },
      {
        titulo: 'Resultado Final da Homologação e Preliminar da Etapa 1',
        data: "",
        arquivo:
          'files/edital_002_2025_ead/Projeto_Web_Academy_Edital_002_2025_Resultado_Final_da_Homologacao_Preliminar_da_Etapa_1.pdf',
      },
      {
        titulo: 'Resultado Final da Etapa 1',
        data: "",
        arquivo:
          'files/edital_002_2025_ead/Projeto_Web_Academy_Edital_002_2025_Resultado_Final_da_Etapa_1.pdf',
      },
      {
        titulo: 'Resultado Final Preliminar Etapa 2',
        data: "",
        arquivo:
          'files/edital_002_2025_ead/Projeto_Web_Academy_Edital_002_2025_Resultado_Final_Preliminar.pdf',
      },
      {
        titulo: 'Resultado Final',
        data: "",
        arquivo:
          'files/edital_002_2025_ead/Projeto_Web_Academy_Edital_002_2025_Resultado_Final.pdf',
      },
      {
        titulo: 'Resultado Final - Distribuição de Bolsa',
        data: "",
        arquivo:
          'files/edital_002_2025_ead/Projeto_Web_Academy_Edital_002_2025_Resultado_Final_Distribuicao_de_Bolsas_Preliminar.pdf',
      },
    ],
  },
  {
    id: 5,
    titulo: 'Edital 001/2025 - Turma 5',
    documentos: [
      {
        titulo: 'Edital 001/2025 - Seleção de Discentes',
        data: "",
        arquivo:
          'files/edital_001_2025/Projeto_Web_Academy_Edital_001_2025 _Seleção de Discentes_Turma_5.pdf',
      },
      {
        titulo: 'Resultado Preliminar da Primeira Fase',
        data: "",
        arquivo:
          'files/edital_001_2025/Projeto_Web_Academy_Edital_ 001_2025_Resultado_Preliminar_da_Primeira_Fase.pdf',
      },
      {
        titulo: 'Resultado Final da Primeira Fase e Convocação para Etapa 2',
        data: "",
        arquivo:
          'files/edital_001_2025/Projeto_Web_Academy_Edital_001_2025_Resultado_Final_da_Primeira_Fase.pdf',
      },
      {
        titulo: 'Resultado Final Preliminar',
        data: "",
        arquivo:
          'files/edital_001_2025/Projeto_Web_Academy_Edital_001_2025_Resultado_Final_Preliminar.pdf',
      },
      {
        titulo: 'Resultado Final',
        data: "",
        arquivo:
          'files/edital_001_2025/Projeto_Web_Academy_Edital_001_2025_Resultado_Final.pdf',
      },
    ],
  },
  {
    id: 4,
    titulo: 'Edital 002/2024 - Turma 4',
    documentos: [
      {
        titulo: 'Edital 002/2024 - Seleção de Discentes',
        data: "",
        arquivo: 'files/edital_002_2024/edital_002_2024.pdf',
      },
      {
        titulo: 'Resultado Preliminar da Primeira Fase',
        data: "",
        arquivo:
          'files/edital_002_2024/Projeto Web Academy - Edital 002_2024 - Resultado Preliminar da Primeira Fase.pdf',
      },
      {
        titulo: 'Resultado Final da Primeira Fase',
        data: "",
        arquivo:
          'files/edital_002_2024/Projeto Web Academy - Edital 002_2024 - ResultadoFinal da Primeira Fase.pdf',
      },
      {
        titulo: 'Convocação para Etapa 2',
        data: "",
        arquivo:
          'files/edital_002_2024/Projeto Web Academy - Edital 002_2024 - Convocacao para Etapa 2.pdf',
      },
      {
        titulo: 'ERRATA 01 - Edital 002/2024',
        data: "",
        arquivo:
          'files/edital_002_2024/Projeto Web Academy - Edital 002_2024 - Selecao de Discentes - ERRATA01.pdf',
      },
      {
        titulo: 'Resultado Final Preliminar',
        data: "",
        arquivo:
          'files/edital_002_2024/Projeto_Web_Academy_Edital 002_2024_Resultado_Final_Preliminar.pdf',
      },
      {
        titulo: 'Resultado Final',
        data: "",
        arquivo:
          'files/edital_002_2024/Projeto_Web_Academy_Edital_002_2024_Resultado_Final.pdf',
      },
    ],
  },
  {
    id: 3,
    titulo: 'Edital 001/2024 - Turma 3',
    documentos: [
      {
        titulo: 'Edital 001/2024 - Seleção de Discentes',
        data: "",
        arquivo: 'files/edital_001_2024/edital_001_2024.pdf',
      },
      {
        titulo: 'Resultado da Homologação das Inscrições',
        data: "",
        arquivo:
          'files/edital_001_2024/homologacao_inscricoes_edital_001_2024.pdf',
      },
      {
        titulo: 'Resultado Final Preliminar da Homologação das Inscrições',
        data: "",
        arquivo:
          'files/edital_001_2024/Edital 001_2024_Resultado_Final_Preliminar.pdf',
      },
      {
        titulo: 'Resultado Final',
        data: "",
        arquivo: 'files/edital_001_2024/Edital_001_2024_-_Resultado_Final.pdf',
      },
    ],
  },
  {
    id: 2,
    titulo: 'Edital 002/2023 - Turma 2',
    documentos: [
      {
        titulo: 'Edital 002/2023 - Seleção de Discentes',
        data: "",
        arquivo: 'files/edital_002_2023/edital_002_2023.pdf',
      },
      {
        titulo: 'ERRATA 01 - Edital 002/2023',
        data: "",
        arquivo: 'files/edital_002_2023/errata_edital_002_2023.pdf',
      },
      {
        titulo: 'ERRATA 02 - Edital 002/2023',
        data: "",
        arquivo: 'files/edital_002_2023/errata2_edital_002_2023.pdf',
      },
      {
        titulo: 'Resultado da Homologação das Inscrições',
        data: "",
        arquivo:
          'files/edital_002_2023/homologacao_inscricoes_edital_002_2023.pdf',
      },
      {
        titulo: 'Errata - Resultado da Homologação das Inscrições',
        data: "",
        arquivo:
          'files/edital_002_2023/errata_homologacao_inscricoes_edital_002_2023.pdf',
      },
      {
        titulo: 'Resultado Final Preliminar',
        data: "",
        arquivo: 'files/edital_002_2023/resultado_edital_002_2023.pdf',
      },
      {
        titulo: 'Resultado Final',
        data: "",
        arquivo: 'files/edital_002_2023/resultado_final_edital_002_2023.pdf',
      },
    ],
  },
  {
    id: 1,
    titulo: 'Edital 001/2023 - Turma 1',
    documentos: [
      {
        titulo: 'Edital 001/2023 - Seleção de Discentes',
        data: "",
        arquivo: 'files/edital_001_2023/edital_001_2023.pdf',
      },
    ],
  },
];

const ToggleContent = ({ isVisible }) => {
  return (
    <>
      {isVisible && (
        <section className="py-5" style={{ backgroundColor: '#ecf0f1' }}>
          <div className="container px-5">
            <div className="row gx-5 mb-5">
              <div className="col">
                {editaisEncerrados.map((edital) => (
                  <div key={edital.id}>
                    <h2 className="fw-bolder fs-5 mb-3">{edital.titulo}</h2>

                    {edital.documentos.map((doc, index) => (
                      <div
                        key={index}
                        className={
                          index === edital.documentos.length - 1
                            ? 'mb-4'
                            : 'mb-2'
                        }
                      >
                        {doc.data && (
                          <div className="medium text-muted">{doc.data}</div>
                        )}
                        {doc.hyperlink !== false ? (
                          <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href={doc.arquivo}
                          >
                            {doc.titulo}
                          </a>
                        ) : (
                          <span
                            style={{
                              textDecoration: 'line-through',
                              color: '#6c757d',
                            }}
                          >
                            {doc.titulo}
                          </span>
                        )}
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default ToggleContent;
